import { render, staticRenderFns } from "./sentiment_post.vue?vue&type=template&id=2a45e572&"
import script from "./sentiment_post.vue?vue&type=script&lang=js&"
export * from "./sentiment_post.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports